<template>
	<div class="module_container full" style="position: relative;">
		<vxe-grid ref="stockwarningList" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<edit-form ref="editForm" :supplieroptions="supplieroptions" :data="currentrow" @submit="editSubmit" />
		<purchase-form ref="purchaseForm" :data="puchasedata" @submit="purchaseFormSubmit" />
		<static-form ref="staticForm" :data="staticdata" @submit="staticFormSubmit" />
	</div>
</template>
<style scoped>
	.module_container {
		box-sizing: border-box;
		padding-bottom: 10px;
	}
</style>
<script>
	import editForm from './form/edit.vue'
	import purchaseForm from './form/purchase.vue'
	import staticForm from './form/static.vue'
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				puchasedata:[],
				staticdata:[],
				modal_title: 'title',
				modal_width: 600,
				modal_height: 500,
				supplieroptions:[],
				currentrow:{},
				list_formConfig: [{
					field: 'a',
					title: '商品编码',
					itemRender: {
						name: '$input'
					}
				},{
					field: 'supplierid',
					title: '供应商',
					itemRender: {
						props:{
							emptyoption:false,
							multiple:true
						},
						name: '$supplier'
					}
				}],
				list_columns: [{
						type: 'checkbox',
						title: '#',
						width: 50,
						fixed: 'left'
					},{
						field: 'goodscode',
						title: '商品编码',
						width: 100,
						fixed: 'left'
					},
					{
						field: 'goodsname',
						title: '商品名称',
						width: 100,
					},
					{
						field: 'goodsmodel',
						title: '商品型号',
						width: 100,
					},
					{
						field: 'weight',
						title: '商品重量(kg)',
						width: 100
					},
					{
						field: 'recommendlevel',
						title: '推荐等级',
						width: 100
					},
					{
						field: 'lock',
						title: '锁定库存',
						width: 100
					},
					{
						field: 'quantity',
						title: '实际库存',
						width: 100
					},
					{
						field: 'warehouseid',
						title: '仓库',
						width: 100,
						fixed: 'left',
						formatter:'warehouse'
					},
					{
						field: 'bottom',
						title: '下限',
						width: 100
					},
					{
						field: 'top',
						title: '上限',
						width: 100
					},
					{
						field: 'custombottom',
						title: '自定义下限',
						width: 100
					},
					{
						field: 'customtop',
						title: '自定义上限',
						width: 100
					},
					{
						field: 'policytype',
						title: '策略类型',
						width: 100
					},
					{
						field: 'suggestnum',
						title: '建议采购数量',
						width: 100
					},
					{
						field: 'buynum',
						title: '近一年购买次数',
						width: 100
					},
					{
						field: 'prochasestandards',
						title: '采购标准',
						width: 100
					},
					{
						field: 'purchasenum',
						title: '本次采购数量',
						width: 100,
						fixed: 'right'
					},
					{
						field: 'suppliernameprovince',
						title: '省份',
						width: 100,
						formatter:'city',
						fixed: 'right',
					},
					{
						field: 'customizedday',
						title: '定做天数',
						width: 100
					},
					{
						field: 'purchaseweight',
						title: '本次采购重量(kg)',
						width: 100
					},
					{
						field: 'mark',
						title: '备注',
						width: 100
					},
					{
						field: 'supplierid',
						title: '供应商',
						width: 200,
						fixed: 'right',
						formatter:'supplier'
					},
					{
						field: 'taxprice',
						title: '采购单价',
						width: 100,
					},
					{
						field: 'taxamount',
						title: '采购金额',
						width: 100,
						fixed: 'right'
					},
					{
						field: 'billCode',
						title: '采购订单',
						width: 100,
						fixed: 'right'
					},
					{
						field: 'warn_time',
						title: '预警时间',
						width: 100,
						formatter: 'datetime',
						fixed: 'right'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>
								]
							}
						}
					}					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.formConfig.span = 4
				gridOptions.toolbarConfig.buttons = [{
					name: '生成采购单',
					status: 'primary',
					code: 'createpurchase'
				},{
					name: '统计',
					status: 'success',
					code: 'static'
				}]
			},
			//page,updateForm,other
			list() {
				return new Promise((resolve) => {
					this.$api.stockwarning.list().then((res) => {
						resolve(res)
					})
				})
			},
			static(){
				this.staticdata = this.$refs.stockwarningList.getTableData().fullData
				this.$nextTick(()=>{
					this.$refs.staticForm.modal_show()
				})
			},
			createpurchase(puchasedata = []){
				if(!puchasedata.length){
					puchasedata = this.$refs.stockwarningList.getCheckboxRecords()
					if(!puchasedata.length){
						this.$message.error('请选择商品')
						return
					}
				}

				this.puchasedata = puchasedata
				this.$nextTick(()=>{
					this.$refs.purchaseForm.modal_show()
				})
			},
			edit(row){
				this.supplieroptions = row.supplieroptions
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.editForm.modal_show()
				})
			},
			editSubmit(e){
				for(let i in e){
					this.currentrow[i] = e[i]
				}
			},
			purchaseFormSubmit(){
				
			},
			staticFormSubmit(e){
				let data = this.$refs.stockwarningList.getTableData().fullData
				let puchasedata = []
				e.forEach((item)=>{
					let arr = data.filter((_item)=>{
						return _item.supplierid == item.id
					})
					puchasedata = puchasedata.concat(arr)
				})

				this.createpurchase(puchasedata)
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			editForm,
			purchaseForm,
			staticForm
		}
	}
</script>